/* global dataLayer, _cc10461, Sailthru */

export function setPageTitleInDataLayer() {
  if (document.title.indexOf(" - Axios") > 0) {
    const slicedTitle = document.title.slice(
      0,
      document.title.indexOf(" - Axios")
    );
    dataLayer.push({ title: slicedTitle });
  }
}

export function setUserInDataLayer(id, isLoggedIn) {
  dataLayer.push({
    "userID Data Layer Var": id,
    "User Logged In": isLoggedIn,
  });
}

export function trackPageView() {
  dataLayer.push({
    Card: false,
    event: "GA_Virtual_Pageviews_Event",
  });
}

export function trackCardViewedInStream({ story, stream, featured, position }) {
  dataLayer.push({
    "Stream Lookup": stream.lookup,
    "Stream Type": stream.type,
    "Stream Display Name": stream.displayName,
    "Stream Query Param Override": stream.override,
    "Stream After Permalink": stream.extraContentSlug,
    Headline: story.headline,
    Authors:
      story.authors &&
      story.authors.map(author => author.display_name).join("|"),
    Editors:
      story.editors &&
      story.editors.map(editor => editor.display_name).join("|"),
    "Published Date": story.published_date,
    "Primary Section": story.primary_section && story.primary_section.name,
    Sections:
      story.sections && story.sections.map(section => section.name).join("|"),
    "Primary Tag": story.primary_tag && story.primary_tag.name,
    Tags: story.tags && story.tags.map(tag => tag.name).join("|"),
    "Post ID": story.id,
    Permalink: story.permalink,
    Card: true,
    "Card Count": 1,
    Rubric: story.rubric && story.rubric.name,
    Featured: featured,
    Position: position + 1,
    event: "GA_Virtual_Pageviews_Event",
  });
}
